var _g, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudioBetaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 24,
    viewBox: "0 0 104 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3054 15.0585C23.167 15.0585 23.9286 14.6059 24.041 13.8963C24.2033 13.0156 23.1919 12.673 21.7435 12.0858C20.2202 11.413 18.4097 10.0918 18.6469 7.75529C18.9716 5.17409 21.5687 3.68164 24.3407 3.68164C26.9503 3.68164 28.4986 5.10069 29.2103 6.75217L26.1512 8.29355C25.6642 7.425 25.0274 6.8745 24.041 6.8745C23.2918 6.8745 22.655 7.19256 22.5551 7.77976C22.3803 8.68501 24.0036 9.13764 25.2147 9.59027C27.1501 10.3243 28.3488 11.7555 28.1115 13.8107C27.7494 16.6855 24.9275 18.337 22.0807 18.337C19.4211 18.337 17.3359 16.7956 16.5742 14.6548L19.4086 12.7831C20.0329 14.0921 20.9444 15.0585 22.3054 15.0585Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3211 8.75968L31.883 5.60352H35.1794L34.6175 8.75968H36.2407L35.7413 11.5244H34.1305L33.0193 17.8245H29.7229L30.8342 11.5244H29.2109L29.7354 8.75968H31.3211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7088 15.7327C41.5329 15.7327 42.1572 15.2556 42.3196 14.3136L43.331 8.75977H46.7647L45.1789 17.8246H41.7202L41.92 16.589C41.2957 17.4576 40.3717 18.0325 39.0607 18.0325C36.7632 18.0325 36.0265 16.6135 36.2887 14.6439L37.3126 8.772H40.9086L39.8972 14.2892C39.8223 14.9987 39.8598 15.7327 40.7088 15.7327Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5202 8.55162C53.9311 8.55162 54.8551 9.26115 55.3546 10.3254L56.7406 2.44727H60.1743L57.4772 17.8121H54.0435L54.2683 16.5521C53.4442 17.4329 52.3579 18.0079 51.0843 18.0079C48.6744 18.0079 47.226 15.8793 47.5382 13.2736C47.9128 10.5701 50.0979 8.55162 52.5202 8.55162ZM52.5951 15.341C53.619 15.3655 54.6429 14.4113 54.8302 13.2859C54.9925 12.246 54.493 11.2796 53.4816 11.2307C52.3953 11.194 51.3465 12.1971 51.1717 13.2859C51.0094 14.3135 51.5338 15.3166 52.5951 15.341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4579 8.75933L62.8846 17.8241H59.5508L61.1241 8.75933H64.4579ZM63.3716 3.70703C64.4579 3.70703 65.3444 4.41656 65.3444 5.48084C65.3444 6.54513 64.4579 7.23019 63.3716 7.23019C62.2853 7.23019 61.3988 6.54513 61.3988 5.48084C61.4112 4.41656 62.2853 3.70703 63.3716 3.70703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4029 8.55078C74.3371 8.55078 76.4348 10.4836 76.0727 13.285C75.6857 16.1231 73.1385 18.0193 70.1168 18.0193C67.1825 18.0193 65.0848 16.0864 65.4469 13.285C65.834 10.4469 68.3812 8.55078 71.4029 8.55078ZM70.379 15.2546C71.4278 15.279 72.3893 14.386 72.5516 13.285C72.6889 12.2452 72.1645 11.3399 71.1406 11.3155C70.0918 11.291 69.1304 12.184 68.968 13.285C68.8307 14.3248 69.3551 15.2301 70.379 15.2546Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18291 9.90941L8.26812 6.26392C8.29309 6.21499 8.31807 6.15382 8.31807 6.09266L8.34304 0.367529C8.34304 -0.0116992 7.84359 -0.134031 7.65629 0.184032L0.00220737 13.5916C-0.135142 13.824 6.18291 9.90941 6.18291 9.90941Z",
    fill: "url(#paint0_linear_5103_7768)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21091 14.0808L4.1257 17.7385C4.10073 17.7875 4.07575 17.8486 4.07575 17.9098L4.05078 23.6349C4.05078 24.0142 4.55023 24.1365 4.73753 23.8184L12.3916 10.3986C12.529 10.1662 6.21091 14.0808 6.21091 14.0808Z",
    fill: "url(#paint1_linear_5103_7768)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0884 9.89648H11.2019H6.21984H2.14932L0.0516213 13.5787C-0.0857277 13.8233 0.0890802 14.1169 0.376265 14.1169H6.23233H10.3153L12.413 10.4347C12.5379 10.1901 12.3631 9.89648 12.0884 9.89648Z",
    fill: "url(#paint2_linear_5103_7768)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.1055 5C79.1055 2.23858 81.344 0 84.1055 0H103.095V6.58102C103.095 9.34245 100.856 11.581 98.0947 11.581H79.1055V5Z",
    fill: "#CF1322"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5898 8.27189V3.30859H83.5575C84.2391 3.30859 84.7561 3.42449 85.1084 3.6563C85.4608 3.88583 85.637 4.2233 85.637 4.66873C85.637 4.91189 85.5663 5.12665 85.4248 5.313C85.2833 5.49708 85.0866 5.6323 84.8345 5.71866C85.1226 5.78229 85.3489 5.91069 85.5135 6.10386C85.6807 6.29702 85.7643 6.53337 85.7643 6.8129C85.7643 7.29014 85.592 7.65148 85.2473 7.89691C84.9027 8.14235 84.4114 8.26734 83.7735 8.27189H81.5898ZM82.7473 6.11067V7.45035H83.7388C84.0114 7.45035 84.2236 7.39354 84.3754 7.27991C84.5297 7.16401 84.6069 7.00493 84.6069 6.80267C84.6069 6.34816 84.3407 6.11749 83.8082 6.11067H82.7473ZM82.7473 5.388H83.6038C84.1876 5.37891 84.4796 5.17324 84.4796 4.77099C84.4796 4.54601 84.405 4.38466 84.2558 4.28694C84.1092 4.18694 83.8764 4.13695 83.5575 4.13695H82.7473V5.388Z",
    fill: "#F5F6F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0949 6.1209H87.8727V7.45035H90.4807V8.27189H86.7152V3.30859H90.473V4.13695H87.8727V5.31982H90.0949V6.1209Z",
    fill: "#F5F6F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5444 4.13695H93.8237V8.27189H92.6663V4.13695H90.9687V3.30859H95.5444V4.13695Z",
    fill: "#F5F6F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9954 7.24923H96.9661L96.5802 8.27189H95.3495L97.4406 3.30859H98.5131L100.616 8.27189H99.3851L98.9954 7.24923ZM97.2786 6.42088H98.6829L97.9769 4.56305L97.2786 6.42088Z",
    fill: "#F5F6F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5103_7768",
    x1: 4.43092,
    y1: 9.29064,
    x2: 8.45663,
    y2: 2.13353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5300D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8100FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5103_7768",
    x1: 7.96645,
    y1: 14.7016,
    x2: 3.94074,
    y2: 21.8587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5300D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8100FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5103_7768",
    x1: 0.00167622,
    y1: 12.0059,
    x2: 12.4534,
    y2: 12.0059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5300D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8000FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5700D4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudioBetaLogo);
export default __webpack_public_path__ + "static/media/studio-beta-logo.1625590386966360623b788bf9310293.svg";
export { ForwardRef as ReactComponent };